// extracted by mini-css-extract-plugin
export default {"floatButton":"FloatButton_floatButton__YMfek","floatButtonCard":"FloatButton_floatButtonCard__WdI8b"};